module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av270-72e5c38f130433863c40eda2fe80ae33.jpg";